import {
  Box,
  Button,
  Typography,
  Stack,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import { useNavigate } from "react-router-dom";

const UpgradeCard = ({
  requiredPlan = "Premium",
  title,
  description,
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        maxWidth: 700,
        mx: "auto",
        my: 6,
        p: 5,
        borderRadius: 4,
        textAlign: "center",
        background:
          "linear-gradient(135deg, #f8fafc 0%, #eef5ff 100%)",
        border: "1px solid #dbeafe",
        boxShadow:
          "0 10px 30px rgba(0,0,0,0.08)",
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          mx: "auto",
          mb: 3,
          borderRadius: "50%",
          background:
            "linear-gradient(135deg, #2f4250, #4f6b80)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LockOutlinedIcon
          sx={{
            color: "#fff",
            fontSize: 40,
          }}
        />
      </Box>

      <Typography
        variant="h4"
        fontWeight={700}
        mb={2}
      >
        {title || "Premium Feature"}
      </Typography>

      <Typography
        color="text.secondary"
        sx={{
          maxWidth: 500,
          mx: "auto",
          mb: 4,
          fontSize: 16,
        }}
      >
        {description ||
          `Upgrade your membership to unlock this feature and enjoy the full InnerPal experience.`}
      </Typography>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent="center"
      >
        <Button
          variant="contained"
          size="large"
          startIcon={
            <WorkspacePremiumOutlinedIcon />
          }
          onClick={() =>
            navigate("/pricing")
          }
          sx={{
            px: 4,
            py: 1.2,
            borderRadius: 3,
          }}
        >
          Upgrade Now
        </Button>

        <Button
          variant="outlined"
          size="large"
          onClick={() =>
            navigate("/pricing")
          }
          sx={{
            px: 4,
            py: 1.2,
            borderRadius: 3,
          }}
        >
          Compare Plans
        </Button>
      </Stack>

      <Typography
        mt={4}
        fontSize={14}
        color="text.secondary"
      >
        Available in {requiredPlan} plan and above
      </Typography>
    </Box>
  );
};

export default UpgradeCard;